import React from 'react'

interface Props {
  height: string
}

const EmptySpace: React.FC<Props> = (props) => {
  const {height} = props

  return <div style={{height: height}}></div>
}

export default EmptySpace
